function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M27.5997 15.6667C27.1729 15.2399 26.594 15.0001 25.9904 15.0001C25.3868 15.0001 24.8079 15.2399 24.3811 15.6667C23.954 16.0934 23.3751 16.333 22.7714 16.333C22.1677 16.333 21.5888 16.0934 21.1617 15.6667C20.7349 15.2399 20.156 15.0001 19.5524 15.0001C18.9488 15.0001 18.3699 15.2399 17.9431 15.6667C17.5162 16.0935 16.9374 16.3333 16.3337 16.3333C15.7301 16.3333 15.1512 16.0935 14.7244 15.6667C14.2974 15.24 13.7184 15.0003 13.1147 15.0003C12.5111 15.0003 11.9321 15.24 11.5051 15.6667C11.0782 16.0935 10.4994 16.3333 9.89574 16.3333C9.29213 16.3333 8.71324 16.0935 8.28641 15.6667C8.07504 15.4551 7.82405 15.2873 7.5478 15.1728C7.27155 15.0583 6.97544 14.9994 6.67641 14.9994C6.37737 14.9994 6.08126 15.0583 5.80501 15.1728C5.52876 15.2873 5.27778 15.4551 5.06641 15.6667L13.6664 25.6667H18.9997L27.5997 15.6667Z",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6663 25.6667L12.333 31H20.333L18.9997 25.6667",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.333 9.66666V13",
  stroke: "#231F20",
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.33317 8.33332C8.33317 7.09565 7.84151 5.90866 6.96634 5.03349C6.09117 4.15832 4.90418 3.66666 3.6665 3.66666V6.99999C3.66658 7.8451 3.89614 8.67433 4.3307 9.39916C4.76525 10.124 5.38848 10.7172 6.13386 11.1155C6.87923 11.5138 7.71877 11.7022 8.56286 11.6606C9.40695 11.619 10.2239 11.349 10.9265 10.8793",
  stroke: "#231F20",
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6078 3.85599C17.0519 2.45253 18.9861 1.66717 20.9998 1.66666V4.99999C20.9998 6.23767 20.5082 7.42465 19.633 8.29982C18.7578 9.17499 17.5708 9.66666 16.3332 9.66666C15.0955 9.66666 13.9085 9.17499 13.0333 8.29982C12.1582 7.42465 11.6665 6.23767 11.6665 4.99999V1.66666C12.9042 1.66666 14.0912 2.15832 14.9663 3.03349C15.8415 3.90866 16.3332 5.09565 16.3332 6.33332",
  stroke: "#231F20",
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.6666 3.78934C10.14 4.0567 8.7283 4.77484 7.61328 5.85134",
  stroke: "#231F20",
  strokeMiterlimit: 10
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M24.3331 8.33332C24.3331 7.09565 24.8247 5.90866 25.6999 5.03349C26.5751 4.15832 27.7621 3.66666 28.9997 3.66666V6.99999C28.9997 7.8451 28.7701 8.67433 28.3356 9.39916C27.901 10.124 27.2778 10.7172 26.5324 11.1155C25.787 11.5138 24.9475 11.7022 24.1034 11.6606C23.2593 11.619 22.4424 11.349 21.7397 10.8793",
  stroke: "#231F20",
  strokeMiterlimit: 10
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M21 3.78934C22.5266 4.0567 23.9383 4.77484 25.0533 5.85134",
  stroke: "#231F20",
  strokeMiterlimit: 10
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M16.333 25.6667V23",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

function SvgBouquetIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBouquetIcon);
export default __webpack_public_path__ + "static/media/bouquet-icon.c43a8211.svg";
export { ForwardRef as ReactComponent };